// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.X8WOA764yXoFYj {
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  padding: 8px 0;
}
@supports not (grid-template-columns: subgrid) {
  .X8WOA764yXoFYj {
    grid-template-columns: [icon] 40px [body] minmax(0, 1fr);
  }
}
@media print {
  .X8WOA764yXoFYj {
    page-break-inside: avoid;
  }
}
@media print {
  .X8WOA764yXoFYj div {
    max-height: 90vh;
  }
}
.Vxo8_5HVQSGTlQ {
  margin-left: -12px;
  padding-left: 8px;
  border-left: 4px solid var(--ds-border-information, #1d7afc);
  background: var(--ds-background-information, #e9f2ff);
}
.MNSgV5ahPwTeQM {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `X8WOA764yXoFYj`,
	"highlightedWrapper": `Vxo8_5HVQSGTlQ`,
	"boardAction": `MNSgV5ahPwTeQM`
};
export default ___CSS_LOADER_EXPORT___;
